import { Box, styled, Typography } from '@mui/material';
import { useTranslation } from '../../../../services/translation/hooks/useTranslation';
import { BlockBoundaryAndOrientationSubmitButton } from './BlockBoundaryAndOrientationSubmitButton';
import BlockDrawStepper from './BlockDrawStepper';
import ClearMapDrawFeaturesButton from './ClearMapDrawFeaturesButton';
import CustomTitleDivider from './CustomTitleDivider';

interface Props {
  handleSendOrientationClick: () => Promise<void>;
  isSubmitDisabled: boolean;
}

const StyledBox = styled(Box)({
  width: '100%',
  padding: '0.5rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const OrientationFormTabActionSection: React.FC<Props> = ({
  handleSendOrientationClick,
  isSubmitDisabled,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        p: '0.5rem',
        border: (theme) => `1px solid ${theme.colors.darkTheme.grey.muted}`,
        borderRadius: (theme) => theme.borderRadius.primary,
        flexDirection: 'column',
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: '100%',
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gridTemplateRows: '1fr',
          gap: '1rem',
        }}
      >
        <Box
          sx={{
            width: '100%',
            height: '100%',
            display: 'grid',
            gridTemplateColumns: '1fr',
            gridTemplateRows: 'min-content 1fr',
            p: '0.5rem',
          }}
        >
          <StyledBox
            sx={{
              flexDirection: 'column',
            }}
          >
            <Typography
              variant='h5'
              sx={{ color: (theme) => theme.colors.common.bloomfieldGreen }}
            >
              {t('Instructions', { ns: 'common' })}
            </Typography>
            <CustomTitleDivider />
          </StyledBox>
          <StyledBox>
            <StyledBox
              sx={{
                width: '90%',
                flexDirection: 'column',
                alignItems: 'flex-start',
              }}
            >
              <Typography variant='body1'>
                {`1. ${t('Select the line tool on the map.', {
                  ns: 'common',
                })}`}
              </Typography>
              <Typography
                variant='body1'
                sx={{ color: (theme) => theme.colors.darkTheme.purple }}
              >
                {`2. ${t(
                  'Draw a line perpendicular to the rows that goes from lower to higher numbers (Number Orientation).',
                  { ns: 'common' }
                )}`}
              </Typography>
              <Typography variant='body1'>
                {`3. ${t('Press "Enter" on your keyboard when done.', {
                  ns: 'common',
                })}`}
              </Typography>
              <Typography variant='body1'>
                {`4. ${t('Select the line tool on the map.', {
                  ns: 'common',
                })}`}
              </Typography>
              <Typography
                variant='body1'
                sx={{ color: (theme) => theme.colors.darkTheme.green }}
              >
                {`5. ${t(
                  'Draw a line in the direction a vehicle will drive down the row (Row Orientation).',
                  { ns: 'common' }
                )}`}
              </Typography>
              <Typography variant='body1'>
                {`6. ${t('Press "Enter" on your keyboard when done.', {
                  ns: 'common',
                })}`}
              </Typography>
              <Typography variant='body1'>
                {`7. ${t('Press the "Submit" Button.', { ns: 'common' })}`}
              </Typography>
            </StyledBox>
          </StyledBox>
        </Box>
        <StyledBox
          sx={{
            maxWidth: '40rem',
            height: '100%',
            justifyContent: 'space-between',
            flexDirection: 'column',
          }}
        >
          <StyledBox
            sx={{
              flexDirection: 'column',
            }}
          >
            <Typography
              variant='h5'
              sx={{ color: (theme) => theme.colors.common.bloomfieldGreen }}
            >
              {t('Current Step', { ns: 'common' })}
            </Typography>
            <CustomTitleDivider />
          </StyledBox>
          <StyledBox>
            <BlockDrawStepper />
          </StyledBox>
          <StyledBox
            sx={{
              flexDirection: 'column',
              gap: '0.5rem',
              maxWidth: '30rem',
            }}
          >
            <ClearMapDrawFeaturesButton />
            <BlockBoundaryAndOrientationSubmitButton
              onClick={handleSendOrientationClick}
              disabled={isSubmitDisabled}
            />
          </StyledBox>
        </StyledBox>
      </Box>
    </Box>
  );
};

export default OrientationFormTabActionSection;
